import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import BottomSheetOptions from 'components/BottomSheetOptions';
import useStoreTranslation from 'hooks/useStoreTranslation';

import { DropdownFilter, DropdownIcon } from './styles';

export interface Data {
  id?: string;
  name: string;
}

interface Props {
  isHistorial?: boolean;
}

const FilterButton = ({
  isHistorial,
}: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const [show, setShow] = useState(false);

  const options: Data[] = [
    {
      id: '0',
      name: t('dashboard.dropdown.pending'),
    },
    {
      id: '1',
      name: t('dashboard.dropdown.requestHistory'),
    },
  ];

  const openModal = (id: string) => {
    switch (id) {
      case '0':
        history.push('/corporate/dashboard');
        break;
      case '1':
        history.push('/corporate/requestHistory');
        break;
      default:
        break;
    }
  };

  return (
    <>
      <DropdownFilter style={isHistorial ? { width: '200px' } : undefined} onClick={() => setShow(true)}>
        {isHistorial ? t('dashboard.dropdown.requestHistory') : t('dashboard.dropdown.pending')}
        <DropdownIcon />
      </DropdownFilter>
      <BottomSheetOptions
        title={t('dashboard.dropdown.title')}
        data={options}
        show={show}
        onChange={openModal}
        onClose={() => setShow(false)}
      />
    </>
  );
};

export default FilterButton;
